import { bucketIndex } from "./measures";

/**
 * The interactions' fixed vocabulary (ADR 0016; docs/admin-app/figures.md › Interactions), without
 * zod, so the web app takes it from `@bt/domain` without the report's schemas.
 */

export const INTERACTION_AREAS = [
  "parts",
  "vehicles",
  "work_orders",
  "templates",
  "orders",
  "to_order",
  "settings",
  "search",
  "data",
] as const;
export type InteractionArea = (typeof INTERACTION_AREAS)[number];

export const INTERACTION_ACTIONS = [
  "open_list",
  "open_item",
  "open_edit",
  "open_create",
  "save",
  "cancel",
  "delete",
  "search",
  "palette",
  "print",
  "copy",
  "email",
] as const;
export type InteractionAction = (typeof INTERACTION_ACTIONS)[number];

/** Lower edges in seconds of how long a form was open: under 10 s, 10–30 s, 30–60 s, 1–3 min, 3–10 min, over 10 min. */
export const FORM_TIME_EDGES_SECONDS = [0, 10, 30, 60, 180, 600] as const;

/** The lower edge of the bucket a form's open time falls in. */
export function formTimeBucket(seconds: number): number {
  return FORM_TIME_EDGES_SECONDS[bucketIndex(Math.max(0, seconds), FORM_TIME_EDGES_SECONDS)] ?? 0;
}
